module.exports = __webpack_public_path__ + "img/Students@1x.e5bb8bb9.png";